__turbopack_context__.v({
  "dotRect": "loader-module-scss-module__YLO3PW__dotRect",
  "loader": "loader-module-scss-module__YLO3PW__loader",
  "pathCircle": "loader-module-scss-module__YLO3PW__pathCircle",
  "pathRect": "loader-module-scss-module__YLO3PW__pathRect",
  "pathTriangle": "loader-module-scss-module__YLO3PW__pathTriangle",
});
